module.exports = __webpack_public_path__ + "img/introduce02.b01d20d9.png";